var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{attrs:{"id":"mapPage","width":"100%","height":"100%","frameborder":"0","src":_vm.iframeUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }